import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const FloatingCTA = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={`fixed bottom-8 right-6 z-50 flex flex-col items-end gap-3 transition-all duration-500 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
      }`}
    >
      {/* Expanded Options */}
      {expanded && (
        <div className="flex flex-col gap-2 items-end animate-fade-in">
          <a
            href="https://smartbusiness.academy"
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap flex items-center gap-2 bg-black/80 backdrop-blur-xl border border-[#8c52ff]/40 text-white text-sm font-medium px-4 py-2.5 rounded-full hover:bg-[#8c52ff]/20 transition-all duration-300 cursor-pointer"
          >
            <i className="ri-graduation-cap-line text-[#8c52ff]" />
            {t('common.floating.academy')}
          </a>
          <a
            href="mailto:info@smartbusinessdigital.com"
            className="whitespace-nowrap flex items-center gap-2 bg-black/80 backdrop-blur-xl border border-[#00c2ff]/40 text-white text-sm font-medium px-4 py-2.5 rounded-full hover:bg-[#00c2ff]/20 transition-all duration-300 cursor-pointer"
          >
            <i className="ri-calendar-line text-[#00c2ff]" />
            {t('common.floating.consultation')}
          </a>
        </div>
      )}

      {/* Main Button */}
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-14 h-14 flex items-center justify-center rounded-full bg-gradient-to-br from-[#8c52ff] to-[#00c2ff] text-white shadow-lg shadow-purple-500/40 hover:scale-110 transition-all duration-300 cursor-pointer relative"
        aria-label="Quick actions"
      >
        <span className="absolute inset-0 rounded-full bg-gradient-to-br from-[#8c52ff] to-[#00c2ff] animate-ping opacity-30" />
        <i className={`text-xl transition-all duration-300 ${expanded ? 'ri-close-line' : 'ri-rocket-line'}`} />
      </button>
    </div>
  );
};

export default FloatingCTA;
